export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/util/eventConsts.js
// module id = 1254
// module chunks = 4